import React from 'react';

import {withRouter} from 'react-router';

import {ErrorContent} from 'app/general/loading/ErrorContent';
import {SPPage} from 'app/general/structures/SPPage';

const BaseSPErrorPage = () => (
  <SPPage>
    <ErrorContent />
  </SPPage>
);

export const SPErrorPage = withRouter(BaseSPErrorPage);
